import { Typography } from "@mui/material"
export type PersonModalType = "EXPIRE_PERSON" | "CANNOT_ARCHIVE_SELF" | "CANNOT_ARCHIVE_HIGHER_USER" | "ONLY_STUDENT_REF"

export const PersonModalMessage = {
    "USER_CAP": (
        <div><Typography>You have reached the cap for active users at your organization, please contact support@futuresthrive for assistance</Typography></div>
    ),
    'EXPIRE_PERSON': (
        <Typography>
            Expiring this record will mean the User will no longer have access. Do you wish to proceed?
        </Typography>
    ), 'CANNOT_ARCHIVE_SELF': (
        <Typography>
            You cannot archive your own account, please contact another admin or your futuresTHRIVE representative for assistance.
        </Typography>
    ),
    'CANNOT_ARCHIVE_HIGHER_USER': (
        <Typography>You do not have permission to archive this user, please contact your futuresTHRIVE representative for assistance</Typography>
    ),
    'ONLY_STUDENT_REF': (
        <div>
            <Typography>This person is the only point of contact for a student(s) at this location </Typography>
            <Typography>Please assign a different person to the student(s) before removing this staff member from the location</Typography>

        </div>
    )
}
